export const MESSAGE_PLAYERS_CHUNK = () => 20


// WEBPACK FOOTER //
// ./state/actions/CMT/Notifications/constants.js